import React from 'react';
import withIcon from '../utilities/withIcon'; 

const IconHelpFilled = () => {
  return (
    <g>
      <path
        d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm-.035 11.59a.743.743 0 0 0-.741.744v.321l.007.101c.049.364.359.644.734.644.41 0 .741-.334.741-.745v-.32l-.006-.102a.743.743 0 0 0-.735-.644zm0-8.94C6.332 2.65 5 4.029 5 5.68c0 .41.332.744.741.744.41 0 .742-.333.742-.745l.006-.138c.07-.775.716-1.401 1.476-1.401.82 0 1.552.735 1.552 1.557 0 .26-.153.668-.357.965a.73.73 0 0 1-.116.115l-.534.41-.215.18c-.676.597-1.05 1.285-1.071 2.273a.743.743 0 0 0 .725.76.743.743 0 0 0 .757-.728c.012-.568.215-.905.681-1.282l.478-.367.134-.107c.156-.132.28-.26.38-.407.363-.527.621-1.215.621-1.812C11 4.052 9.603 2.65 7.965 2.65z"
        
      />
    </g>
  );
};

export default withIcon(IconHelpFilled);
